import { createRejectOnErrorStatus, transformWithErrorBody } from './httpResponse';

const dataServices = angular.module('dataServices', []);

dataServices.service('fleetService', function ($resource, config, $http, Blob, FileSaver, toasterService) {
  const rest = $resource(
    config.api + 'fleet/info',
    {},
    {
      statusGraph: {
        url: config.api + 'fleet/status-graph',
        method: 'GET',
        isArray: true,
      },
      getSignOn: {
        url: config.api + 'fleet/info',
        method: 'GET',
        isArray: true,
      },
      getCarList: {
        url: config.api + 'car/list',
        method: 'GET',
        isArray: true,
      },
      getCarListStatus: {
        url: config.api + 'car/list/status',
        method: 'GET',
        isArray: true,
        params: {
          carIds: '@carIds'
        }
      },
      getTrainsWithCars: {
        url: config.api + 'car/trains-with-cars',
        method: 'GET',
        isArray: true,
      }
    }
  );

  const exportToExcel = function (queryParameters, filename) {
    queryParameters.type = 'XLSX';
    const url = config.api + 'fleet/status';
    return $http
      .get(url, {
        params: queryParameters,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            statusCode: statusCode
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.xlsx');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  const exportToCsv = function (queryParameters, filename) {
    queryParameters.type = 'CSV';
    const url = config.api + 'fleet/status';
    return $http
      .get(url, {
        params: queryParameters,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'text/csv',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], {type: 'text/csv'}),
            statusCode: statusCode
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.csv');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  return {
    getAll: function () {
      return rest.query().$promise;
    },
    getStatusGraph: function (filterSelection) {
      return rest.statusGraph(filterSelection).$promise;
    },
    getSignOn: function () {
      return rest.getSignOn().$promise;
    },
    getCarList: function () {
      return rest.getCarList().$promise;
    },
    getCarListStatus: function (params) {
      return rest.getCarListStatus(params).$promise;
    },
    getTrainsWithCars: function () {
      return rest.getTrainsWithCars().$promise;
    },
    exportToExcel: exportToExcel,
    exportToCsv: exportToCsv,
  };
});

dataServices.service('fileService', function ($resource, config) {
  let rest = $resource(
    config.api + 'uploadFiles',
    {},
    {
      uploadFile: {
        url: config.api + 'uploadfile',
        method: 'POST',
        transformRequest: angular.identity,
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        },
        headers: {
          'Content-Type': undefined,
        },
      },
      acceptUpload: {
        url: config.api + 'headerapproval',
        method: 'POST',
      },
      downloadPackageFile: {
        url: 'service/package-file/:fileName',
        method: 'GET',
        isArray: false,
        responseType: 'arraybuffer',
        transformResponse: function (data, headers, statusCode) {
          return {
            response: new Blob([data], { type: 'application/octet-stream' }),
            headers: headers,
            statusCode: statusCode
          };
        }
      },
    }
  );

  return {
    upload: function (obj) {
      const formdata = new FormData();
      formdata.append('file', obj);
      return rest.uploadFile(formdata).$promise;
    },
    acceptUpload: function (obj) {
      return rest.acceptUpload(obj).$promise;
    },
    downloadPackageFile: fileName => {
      return rest.downloadPackageFile({fileName: fileName}).$promise;
    },
  };
});

dataServices.service('trainService', function ($resource, config) {
  let rest = $resource(
    config.api + 'train/:consist',
    { consist: '@consist' },
    {
      killDriversViewSession: {
        url: config.api + 'train/kill-drivers-view-session',
        method: 'POST',
      },
      startDriversView: {
        url: config.api + 'drivers/:train',
        method: 'POST',
        params: {
          train: '@train'
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            statusCode: statusCode
          };
        }
      },
      stopDriversView: {
        url: config.api + 'drivers/:train',
        method: 'DELETE',
        params: {
          train: '@train'
        },
      },
      getDriversView: {
        url: config.api + 'drivers/image/fleet/:fleetId/train/:trainId',
        method: 'GET',
        params: {
          fleetId: '@fleetId',
          trainId: '@trainId',
          resX: '@resX',
          resY: '@resY',
          touchX: '@touchX',
          touchY: '@touchY',
          maintenanceMode: '@maintenanceMode',
        },
        responseType: 'arraybuffer',
        transformResponse: function (data, headers, statusCode) {
          return {
            data: new Blob([data], { type: 'image/png' }),
            statusCode: statusCode
          };
        }
      },
    }
  );

  return {
    get: function (consist) {
      return rest.get({ consist: consist }).$promise;
    },
    killDriversViewSession: function () {
      return rest.killDriversViewSession().$promise;
    },
    startDriversView: function (trainId) {
      return rest.startDriversView({ train: trainId }).$promise;
    },
    stopDriversView: function (trainId) {
      return rest.stopDriversView({ train: trainId }).$promise;
    },
    getDriversView: function (params) {
      return rest.getDriversView(params).$promise;
    },
  };
});

dataServices.service('systemStatusService', function ($resource, config) {
  const rest = $resource(config.api + 'system-status/', {}, {});

  return {
    getSystemStatus: function () {
      return rest.get().$promise;
    },
  };
});

dataServices.service('EventsService', function ($resource, config) {
  const rest = $resource(
    config.api + '',
    {},
    {
      getActiveFleet: {
        url: config.api + 'event/active',
        method: 'POST',
        isArray: true,
      },
      getActiveFleetList: {
        url: config.api + 'event/active-list',
        method: 'POST',
        isArray: true,
      },
      getActiveFleetListSingle: {
        url: config.api + 'event/active-list/:consist',
        method: 'POST',
        isArray: true,
        params: {
          consist: '@consist',
        },
      },
      getHistoryFleet: {
        url: config.api + 'event/history',
        method: 'POST',
        isArray: true,
      },
      getHistoryTrain: {
        url: config.api + 'event/history/:consist/:count/:skip',
        method: 'GET',
        isArray: true,
        params: {
          consist: '@consist',
          count: '@count',
          skip: '@skip',
        },
      },
      deleteActiveEvent: {
        url: config.api + 'event/active/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        }
      },
      deleteHistoryEvent: {
        url: config.api + 'event/history/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        }
      },
    }
  );

  return {
    getActiveFleet: params => {
      return rest.getActiveFleet(params).$promise;
    },
    getActiveFleetList: params => {
      return rest.getActiveFleetList(params).$promise;
    },
    getActiveFleetListSingle: (params, consist) => {
      return rest.getActiveFleetListSingle({ consist: consist }, params).$promise;
    },
    getHistoryFleet: params => {
      return rest.getHistoryFleet(params).$promise;
    },
    getHistoryTrain: params => {
      return rest.getHistoryTrain({ consist: params.consist, count: params.count, skip: params.skip }).$promise;
    },
    deleteActiveEvent: (params) => {
      return rest.deleteActiveEvent(params).$promise;
    },
    deleteHistoryEvent: (params) => {
      return rest.deleteHistoryEvent(params).$promise;
    }
  };
});

dataServices.service('notificationService', function ($resource, config, $http, $q) {
  const rejectOnErrorStatus = createRejectOnErrorStatus($q);
  const wrapErrorBody = transformWithErrorBody($http.defaults.transformResponse);
  const rest = $resource(
    config.api + 'event/:id',
    {id: '@id'},
    {
      latest: {
        url: config.api + 'event/latest',
        method: 'GET',
        isArray: true,
      },
      history: {
        url: config.api + 'event/history',
        method: 'POST',
        isArray: true,
      },
      historySingle: {
        url: config.api + 'event/history',
        method: 'POST',
        isArray: true,
      },
      latestByTrain: {
        url: config.api + 'event/latest/',
        method: 'GET',
        isArray: true,
        params: {
          skip: '@skip',
          count: '@count',
          id: '@id',
        },
      },
      acknowledge: {
        url: config.api + 'event/acknowledge',
        method: 'PUT',
      },
      update: {
        method: 'PUT',
      },
      audit: {
        url: config.api + 'event/audit',
        method: 'POST',
        isArray: true,
      },
    }
  );

  return {
    getAll: function () {
      return rest.query().$promise;
    },
    get: function (id) {
      return rest.get({ id: id }).$promise;
    },
    latest: function (obj) {
      return rest.latest(obj).$promise;
    },
    getHistoryEvents: function (obj) {
      return $http.post(config.api + 'event/history', obj, { transformResponse: wrapErrorBody })
        .then(rejectOnErrorStatus).then(response => response.data);
    },
    getHistoryEventsSingle: function (params) {
      return rest.historySingle(params).$promise;
    },
    update: function (obj) {
      return rest.update(obj).$promise;
    },
    acknowledge: function (obj) {
      return rest.acknowledge(obj).$promise;
    },
    getAuditEvents: function (obj) {
      return rest.audit(obj).$promise;
    }
  };
});

// todo: add an additional parameter to determine between active, history and condition events
dataServices.service('eventsExportService', function ($http, Blob, FileSaver, toasterService, config) {
  const exportToExcel = function (queryParameters, filename, endpoint) {
    const url = config.api + (endpoint ? endpoint : 'event/latest');
    queryParameters.type = 'XLSX';
    return $http
      .get(url, {
        params: queryParameters,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
            statusCode: statusCode
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.xlsx');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  const exportToCsv = function (queryParameters, filename, endpoint) {
    const url = config.api + (endpoint ? endpoint : 'event/latest');
    queryParameters.type = 'CSV';
    return $http
      .get(url, {
        params: queryParameters,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'text/csv',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], { type: 'text/csv' }),
            statusCode: statusCode,
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.csv');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  return {
    exportToExcel: exportToExcel,
    exportToCsv: exportToCsv,
  };
});

dataServices.service('bearingConditionExportService', function ($http, Blob, FileSaver, toasterService, config) {
  const exportTo = (dataToExport, fileName, exportType) => {
    const url = config.api + "export/bearing-condition";
    return $http
        .post(url, dataToExport, {
          params: {type: exportType.type},
          responseType: 'arraybuffer',
          headers: {
            Accept: exportType.mimeType,
          },
          transformResponse: function (data, headers, statusCode) {
            return {
              blob: new Blob([data], { type: exportType.mimeType }),
              statusCode: statusCode,
            };
          }
        })
        .then(result => {
          if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, fileName + exportType.fileExtension);
          if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
        });
  };

  const exportToExcel = (dataToExport, filename) => exportTo(dataToExport, filename,
      {type: 'XLSX', fileExtension: '.xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
  const exportToCsv = (dataToExport, filename) => exportTo(dataToExport, filename,
      {type: 'CSV', fileExtension: '.csv', mimeType: 'text/csv'});

  return {
    exportToExcel: exportToExcel,
    exportToCsv: exportToCsv
  };
});

dataServices.service('historyExportService', function ($http, Blob, FileSaver, toasterService, config) {
  const exportToExcel = function (params) {
    params.export = 'XLSX';
    params.skip = null;
    params.count = null;

    const url = config.api + 'analysis/export';
    return $http
      .get(url, {
        params: params,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            statusCode: statusCode
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.xlsx');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  const exportToCsv = function (params) {
    params.export = 'CSV';
    params.skip = null;
    params.count = null;
    const url = config.api + 'analysis/export';
    return $http
      .get(url, {
        params: params,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'text/csv',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            blob: new Blob([data], {type: 'text/csv'}),
            statusCode: statusCode
          };
        }
      })
      .then(result => {
        if (result.data.statusCode === 200) FileSaver.saveAs(result.data.blob, filename + '.csv');
        if (result.data.statusCode !== 200) toasterService.error('export.export-failed', 'error-type.NO_DATA_FOR_REQUEST');
      });
  };

  return {
    exportToExcel: exportToExcel,
    exportToCsv: exportToCsv,
  };
});

dataServices.service('analysisService', function ($resource, config, $http, $q) {
  const rejectOnErrorStatus = createRejectOnErrorStatus($q);
  const wrapErrorBody = transformWithErrorBody($http.defaults.transformResponse);
  const rest = $resource(
    config.api + 'analysis',
    {},
    {
      groupsById: {
        url: config.api + 'analysis/groups-by-id',
        method: 'GET',
        isArray: true,
      },
      eventsStacked: {
        url: config.api + 'analysis/events-stacked',
        method: 'GET',
        isArray: true,
      },
      groupsStacked: {
        url: config.api + 'analysis/subsystems-stacked',
        method: 'GET',
        isArray: true,
      },
      eventsByGroup: {
        url: config.api + 'analysis/events-by-group',
        method: 'GET',
        isArray: true,
      },
      eventInfo: {
        url: config.api + 'event/info',
        method: 'GET',
        isArray: true,
      },
      eventInfoVersion: {
        url: config.api + 'event/info/version',
        method: 'GET',
        isArray: false,
      },
      descriptorModulesVersion: {
        url: config.api + 'descriptor/modules/version',
        method: 'GET',
        isArray: false,
      },
      signalsVersion: {
        url: config.api + 'signals/config/version',
        method: 'GET',
        isArray: false,
      },
      uploadEventInfo: {
        url: config.api + 'event/info',
        method: 'POST',
        isArray: false,
        transformRequest: angular.identity,
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        },
        headers: {
          'Content-Type': undefined,
        },
      },
      uploadDescriptorModules: {
        url: config.api + 'descriptor/modules',
        method: 'POST',
        isArray: false,
        transformRequest: angular.identity,
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        },
        headers: {
          'Content-Type': undefined,
        },
      },
      uploadSignals: {
        url: config.api + 'signals/config',
        method: 'POST',
        isArray: false,
        transformRequest: angular.identity,
        transformResponse: function (data, headers, statusCode) {
          return {
            data: data,
            headers: headers(),
            statusCode: statusCode
          };
        },
        headers: {
          'Content-Type': undefined,
        },
      },
      carList: {
        url: config.api + 'car/all-sorted',
        method: 'GET',
        isArray: true,
      },
      eventHeatMap: {
        url: config.api + 'analysis/fault-heat-map',
        method: 'GET',
        isArray: false,
      },
      subsystemInfo: {
        url: config.api + 'analysis/subsystem-list',
        method: 'GET',
        isArray: true,
      },
      eventHistory: {
        url: config.api + 'analysis/event-history-data',
        method: 'GET',
        isArray: true,
      },
    }
  );

  return {
    groupsById: function (params) {
      return rest.groupsById(params).$promise;
    },
    eventsStacked: function (params) {
      return rest.eventsStacked(params).$promise;
    },
    groupsStacked: function (params) {
      return rest.groupsStacked(params).$promise;
    },
    eventsByGroup: function (params) {
      return rest.eventsByGroup(params).$promise;
    },
    eventInfo: function () {
      return rest.eventInfo().$promise;
    },
    envDataVariables: function () {
      return $http.get(config.api + 'event/info/variables', {
        transformResponse: wrapErrorBody,
      }).then(rejectOnErrorStatus).then(response => {
        if (!Array.isArray(response.data)) {
          return $q.reject(new Error('Invalid environment data metadata response'));
        }
        return response.data;
      });
    },
    eventInfoVersion: function () {
      return rest.eventInfoVersion().$promise;
    },
    descriptorModulesVersion: function () {
      return rest.descriptorModulesVersion().$promise;
    },
    signalsVersion: function () {
      return rest.signalsVersion().$promise;
    },
    uploadEventInfo: function (file) {
      const formData = new FormData();
      formData.append('file', file);
      return rest.uploadEventInfo(formData).$promise;
    },
    uploadDescriptorModules: function (file) {
      const formData = new FormData();
      formData.append('file', file);
      return rest.uploadDescriptorModules(formData).$promise;
    },
    uploadSignals: function (file) {
      const formData = new FormData();
      formData.append('file', file);
      return rest.uploadSignals(formData).$promise;
    },
    carList: function () {
      return rest.carList().$promise;
    },
    eventHeatMap: function (params) {
      return rest.eventHeatMap(params).$promise;
    },
    subsystemInfo: function () {
      return rest.subsystemInfo().$promise;
    },
    eventHistory: function (params) {
      return rest.eventHistory(params).$promise;
    },
  };
});

dataServices.service('filterPresetService', function ($resource, config, $q) {
  const rest = $resource(
    config.api + 'event-filter-preset',
    {},
    {
      getAll: {
        url: config.api + 'event-filter-preset/list',
        method: 'GET',
        isArray: true,
      },
      create: {
        url: config.api + 'event-filter-preset',
        method: 'POST',
        isArray: false,
      },
      update: {
        url: config.api + 'event-filter-preset/:id',
        method: 'PUT',
        params: {
          id: '@id',
        },
        isArray: false,
      },
      delete: {
        url: config.api + 'event-filter-preset/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
        isArray: false,
      },
    }
  );

  return {
    getAll: function () {
      return rest.getAll().$promise.then(function(response) {
        // Handle both array and object responses
        if (Array.isArray(response)) {
          return response;
        } else if (response && typeof response === 'object') {
          // If backend returns an object, try to extract the array
          // Common patterns: {data: [...], content: [...], list: [...]}
          return response.data || response.content || response.list || response || [];
        }
        return [];
      });
    },
    create: function (preset) {
      return rest.create(preset).$promise;
    },
    update: function (id, preset) {
      return rest.update({ id: id }, preset).$promise;
    },
    delete: function (id) {
      return rest.delete({ id: id }).$promise;
    },
  };
});

dataServices.service('KeyManagerService', function ($resource, config) {
  const rest = $resource(
    config.api,
    {},
    {
      generateKey: {
        url: config.api + 'key',
        method: 'POST',
      },
      generatePackage: {
        url: config.api + 'key/:id/create_package',
        method: 'GET',
        params: {
          id: '@id',
        },
        transformResponse: function (data, headers, statusCode) {
          return {
            statusCode: statusCode
          };
        }
      },
      deleteKey: {
        url: config.api + 'key/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
      },
      getKeys: {
        url: config.api + 'key',
        method: 'GET',
        isArray: true
      },
      getKey: {
        url: config.api + 'key/:id',
        method: 'GET',
        params: {
          id: '@id',
        },
      },
    }
  );

  return {
    generateKey: function (payload) {
      return rest.generateKey(payload).$promise;
    },
    generatePackage: function (id) {
      return rest.generatePackage({ id: id }).$promise;
    },
    deleteKey: function (id) {
      return rest.generateKey({ id: id }).$promise;
    },
    getKey: function (id) {
      return rest.getKey({ id: id }).$promise;
    },
    getKeys: function () {
      return rest.getKeys().$promise;
    }
  };
});

dataServices.service('tipTokenService', function ($resource, config) {
  const tokenRest = $resource(config.api + 'tip-path', {}, {});

  return {
    getTipToken: function () {
      return tokenRest.get().$promise;
    },
  };
});

dataServices.service('psaService', function ($resource, config) {
  const rest = $resource(
    config.api + 'psa',
    {id: '@id'},
    {
      emus: {
        url: config.api + 'psa/emus',
        method: 'GET',
        isArray: true,
      },
      trains: {
        url: config.api + 'psa/trains',
        method: 'GET',
        isArray: true,
      },
      scripts: {
        url: config.api + 'psa/script/list',
        method: 'GET',
        isArray: true,
      },
      addScript: {
        url: config.api + 'psa/script/new',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      editScript: {
        url: config.api + 'psa/script/edit/:id',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      deleteScript: {
        url: config.api + 'psa/script/delete/:id',
        method: 'DELETE',
      },
      events: {
        url: config.api + 'psa/script/events',
        method: 'GET',
        isArray: false,
      },
      cars: {
        url: config.api + 'psa/cars',
        method: 'GET',
        isArray: true,
      },
    }
  );

  return {
    getTrains: function (filterSelection) {
      return rest.query(filterSelection).$promise;
    },
    getEmus: function (filterSelection) {
      return rest.emus(filterSelection).$promise;
    },
    getScripts: function (filterSelection) {
      return rest.scripts(filterSelection).$promise;
    },
    getEvents: function (filterSelection) {
      return rest.events(filterSelection).$promise;
    },
    getCars: function (filterSelection) {
      return rest.cars(filterSelection).$promise;
    },
    addScript: function (obj) {
      return rest.addScript(obj).$promise;
    },
    editScript: function (obj) {
      return rest.editScript(obj).$promise;
    },
    deleteScript: function (id) {
      return rest.deleteScript({ id: id }).$promise;
    },
  };
});

dataServices.service('PackageService', function ($resource, config) {
  const rest = $resource(
    config.api + 'descriptor',
    {},
    {
      listPackages: {
        url: config.api + 'files',
        method: 'GET',
        isArray: true,
      },
      deletePackage: {
        url: config.api + 'deletefile/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      listDescriptors: {
        url: config.api + 'descriptor/list',
        method: 'GET',
        isArray: true,
      },
      listModules: {
        url: config.api + 'descriptor/modules',
        method: 'GET',
        isArray: true,
      },
      listModulesByFamily: {
        url: config.api + 'descriptor/modules/:family',
        method: 'GET',
        isArray: true,
      },
      getUploadProgressPerFile: {
        url: config.api + 'progress/file/:fileid',
        method: 'GET',
        isArray: true,
        params: {
          fileid: '@fileid',
        },
      },
      getUploadProgressList: {
        url: config.api + 'progress/:consist',
        method: 'GET',
        isArray: true,
        params: {
          consist: '@consist',
        },
      },
      getPackageUploadStatusList: {
        url: config.api + 'progress/status/:consist/:carNumber/:moduleId',
        method: 'GET',
        isArray: true,
        params: {
          consist: '@consist',
          carNumber: '@carNumber',
          moduleId: '@moduleId'
        },
      },
      getActivationProgressList: {
        url: config.api + 'activation-progress/:consist',
        method: 'GET',
        isArray: true,
        params: {
          consist: '@consist',
        },
      },
      getAvailablePackages: {
        url: config.api + 'car_files/:consist',
        method: 'GET',
        isArray: true,
        params: {
          consist: '@consist',
        },
      },
      addDescriptor: {
        url: config.api + 'descriptor/new',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      editDescriptor: {
        url: config.api + 'descriptor/edit/:id',
        method: 'PUT',
        params: {
          id: '@id',
        },
      },
      deleteDescriptor: {
        url: config.api + 'descriptor/delete/:id',
        method: 'DELETE',
        params: {
          id: '@id',
        },
      },
      uploadPackage: {
        url: config.api + 'train_upload',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      uploadPackageToTrains: {
        url: config.api + 'train_uploads',
        method: 'POST',
        isArray: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      },
      abortUpload: {
        url: config.api + 'progress/abort/:consist/:downloadId',
        method: 'POST',
        params: {
          consist: '@consist',
          downloadId: '@downloadId',
        },
      },
      dismissUpload: {
        url: config.api + 'progress/dismiss/:downloadId',
        method: 'POST',
        params: {
          downloadId: '@downloadId',
        },
      },
    }
  );

  return {
    getAllDescriptors: function () {
      return rest.listDescriptors().$promise;
    },
    getModules: function () {
      return rest.listModules().$promise;
    },
    getModulesByFamily: function (family) {
      return rest.listModulesByFamily({ family: family }).$promise;
    },
    getAllPackages: function () {
      return rest.listPackages().$promise;
    },
    deletePackage: function (id) {
      return rest.deletePackage({ id: id }).$promise;
    },
    addDescriptor: function (obj) {
      return rest.addDescriptor(obj).$promise;
    },
    editDescriptor: function (status, id) {
      return rest.editDescriptor({ id: id }, status).$promise;
    },
    deleteDescriptor: function (id) {
      return rest.deleteDescriptor({ id: id }).$promise;
    },
    uploadPackage: function (obj) {
      return rest.uploadPackage(obj).$promise;
    },
    uploadPackageToTrains: function (obj) {
      return rest.uploadPackageToTrains(obj).$promise;
    },
    getUploadProgressPerFile: function (fileid) {
      return rest.getUploadProgressPerFile({ fileid: fileid }).$promise;
    },
    getUploadProgressList: function (consist) {
      return rest.getUploadProgressList({ consist: consist }).$promise;
    },
    getPackageUploadStatusList: function (consist, carNumber, moduleId) {
      return rest.getPackageUploadStatusList({consist, carNumber, moduleId}).$promise;
    },
    getActivationProgressList: function (consist) {
      return [];
    },
    getAvailablePackages: function (consist) {
      return rest.getAvailablePackages({ consist: consist }).$promise;
    },
    abortUpload: function (consist, downloadId) {
      return rest.abortUpload({ consist: consist }, { downloadId: downloadId }).$promise;
    },
    dismissUpload: function (downloadId) {
      return rest.dismissUpload({ downloadId: downloadId }).$promise;
    },
  };
});

dataServices.service('MTService', function ($resource, config) {
  const rest = $resource(
    config.api + 'mt',
    {},
    {
      topology: {
        url: config.api + 'train/:id/topology',
        method: 'GET',
      },
    }
  );

  return {
    getTopology: function (id) {
      return rest.topology({ id: id }).$promise;
    },
  };
});

dataServices.service('ConditionService', function ($resource, config) {
  const rest = $resource(
    config.api + '/service/condition',
    {id: '@id'},
    {
      getGraphData: {
        url: config.api + 'condition/graph',
        method: 'GET',
        isArray: true,
        params: {
          trainId: '@trainId',
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
        },
      },
      getGraphDataForTimeRange: {
        url: config.api + 'condition/graph/between',
        method: 'GET',
        isArray: true,
        params: {
          trainId: '@trainId',
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          start: '@start',
          end: '@end',
        },
      },
      getGraphDataBeforeDate: {
        url: config.api + 'condition/graph/before',
        method: 'GET',
        isArray: true,
        params: {
          trainId: '@trainId',
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          end: '@end',
        },
      },
      getGraphDataAfterDate: {
        url: config.api + 'condition/graph/after',
        method: 'GET',
        isArray: true,
        params: {
          trainId: '@trainId',
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          start: '@start',
        },
      },

      getAggregationsForTimeRange: {
        url: config.api + 'condition/aggregation/between',
        method: 'GET',
        isArray: true,
        params: {
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          start: '@start',
          end: '@end',
        },
      },
      getAggregationsBeforeTime: {
        url: config.api + 'condition/aggregation/before',
        method: 'GET',
        isArray: true,
        params: {
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          end: '@end',
        },
      },
      getAggregationsAfterTime: {
        url: config.api + 'condition/aggregation/after',
        method: 'GET',
        isArray: true,
        params: {
          carId: '@carId',
          assetId: '@assetId',
          valueType: '@valueType',
          start: '@start',
        },
      },

      getTrainData: {
        url: config.api + 'condition/latest',
        method: 'get',
        isArray: true,
      },

      getAssetConditions: {
        url: config.api + 'condition/latest',
        method: 'post',
        isArray: true,
      },

      getLatestForCars: {
        url: config.api + 'condition/latest/cars',
        method: 'get',
        isArray: true,
        params: {
          carIds: '@carIds'
        }
      },

      getAssetConditionsForCars: {
        url: config.api + 'condition/latest/cars',
        method: 'post',
        isArray: true,
        params: {
          carIds: '@carIds'
        }
      },
      getConditionForCars: {
        url: config.api + 'condition/fleet-condition/cars',
        method: 'get',
        isArray: true,
        params: {
          carIds: '@carIds'
        }
      },

      getFleetData: {
        url: config.api + 'condition/bogie/trains',
        method: 'GET',
        isArray: true,
      },
      getCategoryData: {
        url: config.api + 'condition/latest-category',
        method: 'GET',
        isArray: true,
        params: {
          carId: '@carId',
          category: '@category',
        },
      },
      getCiConfig: {
        url: config.api + 'condition/ci_type/:ciType/',
        method: 'GET',
        params: {
          ciType: '@ciType',
        },
      },
      saveCiConfig: {
        url: config.api + 'condition/ci_type/:ciType/',
        method: 'PUT',
        params: {
          ciType: '@ciType',
        },
      },

      /*
       * Condition Alerts
       */
      getAlertsForCI: {
        url: config.api + 'condition/alerts/stream',
        method: 'GET',
        isArray: true,
        params: {
          assetId: '@assetId',
          ciType: '@ciType',
          start: '@start',
          end: '@end'
        },
      },
    }
  );

  return {
    getGraphData: function (params) {
      return rest.getGraphData(params).$promise;
    },
    getGraphDataForTimeRange: function (params) {
      return rest.getGraphDataForTimeRange(params).$promise;
    },
    getGraphDataBeforeDate: function (params) {
      return rest.getGraphDataBeforeDate(params).$promise;
    },
    getGraphDataAfterDate: function (params) {
      return rest.getGraphDataAfterDate(params).$promise;
    },

    getAggregationsForTimeRange: function (params) {
      return rest.getAggregationsForTimeRange(params).$promise;
    },
    getAggregationsBeforeTime: function (params) {
      return rest.getAggregationsBeforeTime(params).$promise;
    },
    getAggregationsAfterTime: function (params) {
      return rest.getAggregationsAfterTime(params).$promise;
    },

    getTrainData: function () {
      return rest.getTrainData().$promise;
    },
    getAssetConditions: function (assetFilter) {
      // assetFilter: {assetType: "BOGIE", cars (optional): ["91223"]}
      return rest.getAssetConditions(assetFilter).$promise;
    },
    getLatestForCars: function(params) {
      return rest.getLatestForCars(params).$promise;
    },
    getConditionForCars: function(params) {
      return rest.getConditionForCars(params).$promise;
    },
    getFleetData: function () {
      return rest.getFleetData().$promise;
    },
    getCategoryData: function (params) {
      return rest.getCategoryData(params).$promise;
    },
    getCiConfig: function (params) {
      return rest.getCiConfig(params).$promise;
    },
    saveCiConfig: function (params, obj) {
      return rest.saveCiConfig(params, obj).$promise;
    },

    /* Condition Alerts */
    getAlertsForCI: function(params) {
      return rest.getAlertsForCI(params).$promise;
    },
  };
});

dataServices.service('ConditionAlertService', function($resource, config) {
  const rest = $resource(
    config.api + '',
    {},
    {
      getAlerts: {
        url: config.api + 'condition/alerts',
        method: 'GET',
        isArray: true
      },
    }
  );

  return {
    getAlerts: () => {
      return rest.getAlerts().$promise;
    },
  };
});

dataServices.service('ConditionEventService', function($resource, config) {
  const rest = $resource(
    config.api + '',
    {},
    {
      getConditionEvents: {
        url: config.api + 'condition/events',
        method: 'POST',
        isArray: true,
      },
      getActiveConditionEvents: {
        url: config.api + 'condition/events/active',
        method: 'POST',
        isArray: true,
      },
      getInactiveConditionEvents: {
        url: config.api + 'condition/events/inactive',
        method: 'POST',
        isArray: true,
      },
    }
  );
  
  return {
    getConditionEvents: (params) => {
      return rest.getConditionEvents(params).$promise;
    },
    getActiveConditionEvents: (params) => {
      return rest.getActiveConditionEvents(params).$promise;
    },
    getInactiveConditionEvents: (params) => {
      return rest.getInactiveConditionEvents(params).$promise;
    },
  };
});

dataServices.service('FleetConditionService', function($resource, config) {
  const rest = $resource(
    config.api + '',
    {},
    {
      getTrainCondition: {
        url: config.api + 'condition/fleet-condition',
        method: 'POST',
        isArray: true,
      },
    }
  );

  return {
    getTrainCondition: trainCarMap => {
      return rest.getTrainCondition(trainCarMap).$promise;
    },
  };
});


dataServices.service('CarService', function($resource, config) {
  const rest = $resource(
      config.api + '',
      {},
      {
        carListForConsist: {
          url: config.api + 'car/:consist',
          method: 'GET',
          isArray: true,
          params: {
            consist: '@consist'
          }
        },
      }
  );

  return {
    carListForConsist: function(params) {
      return rest.carListForConsist(params).$promise;
    },
  };
});

dataServices.service('TrainSoftwareStatusService', function($resource, config) {
  const rest = $resource(
      config.api + '',
      {},
      {
        getFleetSoftwareStatus: {
          url: config.api + 'software-status/',
          method: 'GET',
          isArray: true,
        },
        
        getTrainSoftwareStatus: {
          url: config.api + 'software-status/:trainId',
          method: 'GET',
          isArray: false,
          params: {
             trainId: '@trainId'
           }
        },
      }
  );
  return {
    getFleetSoftwareStatus: function(params) {
      return rest.getFleetSoftwareStatus(params).$promise;
    },
    getTrainSoftwareStatus: function(params) {
      return rest.getTrainSoftwareStatus(params).$promise;
    },
  };
});

dataServices.service('SyncSubscriptionService', function($resource, config) {
  const rest = $resource(
      config.api + '',
      {},
      {
        getSyncSubscriptions: {
          url: config.api + 'sync-subscriptions/',
          method: 'GET',
          isArray: true,
        },
        
        addSyncSubscription: {
          url: config.api + 'sync-subscription/add',
          method: 'POST',
          isArray: true,
          params: {
             trainId: '@trainId'
           }
        },

        removeSyncSubscription: {
          url: config.api + 'sync-subscription/remove',
          method: 'POST',
          isArray: true,
          params: {
             trainId: '@trainId'
           }
        },
      }
  );
  return {
      getSyncSubscriptions: function(params) {
      return rest.getSyncSubscriptions(params).$promise;
    },
      addSyncSubscription: function(params) {
      return rest.addSyncSubscription(params).$promise;
    },
      removeSyncSubscription: function(params) {
      return rest.removeSyncSubscription(params).$promise;
    },
  };
});
